var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AssetsManager } from '../assets/AssetsManager';
import { ViewNodeBuilder } from './ViewNodeBuilder';
import { MaterialsManager } from '../materials';
export var StandardViewNodes;
(function (StandardViewNodes) {
    StandardViewNodes["Model3d"] = "Model3d";
    StandardViewNodes["Component"] = "Component";
    StandardViewNodes["Light"] = "Light";
})(StandardViewNodes || (StandardViewNodes = {}));
export class ViewBuilder {
    constructor(context) {
        this.context = context;
        this.registeredViewNodes = new Map();
        this.createdNodes = new Map();
        this.assetsManager = new AssetsManager();
        this.materialsManager = new MaterialsManager(this.assetsManager);
        this.builder = new ViewNodeBuilder(this, this.assetsManager);
        this.materialsChanges = [];
    }
    getContext() {
        return this.context;
    }
    clear() {
        this.createdNodes.clear();
        this.builder.clear();
    }
    buildTo(root) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.prefetchAssets();
            this.updateMaterials();
            this.builder.mountTo(root);
            this.materialsChanges = [];
        });
    }
    test(_node) { }
    registerViewNode(type, nodeFactory) {
        if (this.registeredViewNodes.has(type)) {
            throw new Error('ViewNode with type "' + type + '" already registered!');
        }
        this.registeredViewNodes.set(type, nodeFactory);
    }
    createViewNode(options) {
        const { type, key, params } = options;
        const nodeFactory = this.registeredViewNodes.get(type);
        if (!nodeFactory) {
            throw new Error('Node with type "' + type + '" not registered!');
        }
        if (this.createdNodes.has(key)) {
            throw new Error(`Duplicated node key ${key}`);
        }
        const node = nodeFactory(key);
        node.init(params);
        this.createdNodes.set(key, node);
        return node;
    }
    addViewNode(options) {
        return this.builder.addViewNode(options);
    }
    addModel3dNode(options) {
        return this.builder.addModel3dNode(options);
    }
    addComponentNode(options) {
        return this.builder.addComponentNode(options);
    }
    addLightNode(options) {
        return this.builder.addLightNode(options);
    }
    addMaterial(options) {
        this.materialsChanges.push(() => this.materialsManager.addMaterial(options));
    }
    addTexture(options) {
        this.assetsManager.wantsAssets([
            {
                key: options.key,
                type: 'Texture',
                url: options.params.url,
                params: options.params,
            },
        ]);
    }
    prefetchAssets() {
        return __awaiter(this, void 0, void 0, function* () {
            for (const node of this.createdNodes.values()) {
                const nodeWantedAssets = node.getPrefetchAssets();
                this.assetsManager.wantsAssets(nodeWantedAssets);
            }
            yield this.assetsManager.loadMissingAssets();
        });
    }
    connectNodes(params) {
        this.builder.connectNodes(params);
    }
    updateMaterials() {
        this.materialsChanges.forEach((action) => action());
    }
}
//# sourceMappingURL=ViewBuilder.js.map